

import "@/components/Vant";
import axios from 'axios';
import router from '../router'
// import store from '../store'
import { getToken,removeToken } from '@/utils/auth'
// import Config from '@/settings'
// import Cookies from 'js-cookie'
import {Toast} from 'vant'
// 创建axios实例
console.log('axios',axios)
const service = axios.create({
    baseURL: process.env.VUE_APP_URL, // api 的 VUE_APP_URL
    timeout: 50000 // 请求超时时间(因为需要调试后台,所以设置得比较大)
});
console.log('base_url',process.env.VUE_APP_URL)
// request拦截器
service.interceptors.request.use(
    
    config => {
        if (getToken()) {
            config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        if(config.url=='/api/users/updateAvatar'){
            config.headers['Content-Type'] = 'multipart/form-data'
        }else{
            config.headers['Content-Type'] = 'application/json'
        }
        
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        const code = response.status
        console.log('base_url',process.env.VUE_APP_URL)
        if (code < 200 || code > 300) {

            Toast(response.message);

            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        console.log(error.response)
        console.log('base_url',process.env.VUE_APP_URL)
        let code = 0
        // try {
            code = error.response.data.status
        // } catch (e) {
        //     if (error.toString().indexOf('Error: timeout') !== -1) {
        //         Toast('网络请求超时');
        //         return Promise.reject(error)
        //     }
        // }
        if (code) {
            
            if (code === 401) {
                removeToken()
                router.push({ path: '/login' })

            } else if (code === 403) {
                router.push({ path: '/401' })
            } else {
                const errorMsg = error.response.data.message
                if (errorMsg !== undefined) {

                    Toast(errorMsg)
                }
            }
        } else {

            Toast( '接口请求失败')
        }
        return Promise.reject(error)
    }
)
export default service
